import React from 'react';
import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import DestinationMainNav from './Features/DestinationMainNav/DestinationMainNav';

interface IProps {
  title?: string;
}

const Main = (props: IProps): JSX.Element => {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<DestinationMainNav />} />
      </Routes>
    </Router>
  );
};

export default Main;
